export interface GetEntitiesParams {
  filter?: EntitiesFilter;
  searchString?: string;
  cursor?: number;
  pageSize?: number;
  /** Allow dynamic filter dependency values (e.g., country for city filter) */
  [key: string]: any;
}

export enum EntitiesFilter {
  DUPLICATES = 'DUPLICATES',
  ERRORS = 'ERRORS',
  WARNINGS = 'WARNINGS',
}
